module.exports = __webpack_public_path__ + "static/media/PROD_JW1.6140d582.png";